module.exports = __webpack_public_path__ + "static/media/Logos.6425e162.png";